// extracted by mini-css-extract-plugin
export default {"content":"ProfilePageLayout_content__8N8hL"};